module.exports = [{"name":"1","orientation":"horizontal"},{"name":"2","orientation":"vertical"},{"name":"3","orientation":"vertical"},{"name":"4","orientation":"horizontal"},{"name":"5","orientation":"horizontal"},{"name":"6","orientation":"vertical"},{"name":"7","orientation":"horizontal"},{"name":"8","orientation":"vertical"}]


//////////////////
// WEBPACK FOOTER
// ./src/photos.json
// module id = 47
// module chunks = 0